import { SeoRenderer } from "../../../../common/helpers/seo";

import loadableComponent from "./loadable";

export default {
    component: loadableComponent,
    renderSeo: (_store, allMessage: any, lang: string) => {
        SeoRenderer({
            title: allMessage["menu.editor"],
            description: allMessage["choir.seo.description"],
            allMessage,
            lang,
            app: "choir"
        });
    },
};
